import { shape, string, number } from "prop-types";

export const OptionShape = shape({
  id: number,
  subLineItemId: number,
  category: string
});
export default OptionShape;
